<template>
    <div>
        <section class="services py-26">
            <div class="text-center">
                <h4 class="hZUCZe">{{ $t('Trust, Innovation and Solutions within Your Reach') }}</h4>
                <h2 class="text-h2-sans text-center">{{ $t("Discover why JLHSOFT is Our Customers' Choice.") }}</h2>
            </div>
            <div class="row" style="margin: 0; padding: 0;">
                <div class="col-md-4 mt-10">
                    <div class="sr-border">
                        <img :src="streamlined" alt="">
                        <h4 class="mt-3 mb-0 hZUCZe">{{ $t('Streamlined Development') }}</h4>
                        <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We create customized solutions for different platforms, ensuring performance, usability and scalability to meet the needs of your business.') }}</p>
                    </div>
                </div>
                <div class="col-md-4 mt-10">
                    <div class="sr-border">
                        <img :src="performance" alt="">
                        <h4 class="mt-3 mb-0 hZUCZe">{{ $t('High Performance') }}</h4>
                        <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We maintain the highest quality standards in all our work, ensuring that each project is executed with precision and excellence.') }}</p>
                    </div>
                </div>
                <div class="col-md-4 mt-10">
                    <div class="sr-border">
                        <img :src="publics" alt="">
                        <h4 class="mt-3 mb-0 hZUCZe">{{ $t('Customer Orientation') }}</h4>
                        <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We are dedicated to understanding and meeting the unique needs of each client, offering customized solutions that generate tangible results.') }}</p>
                    </div>
                </div>
                <div class="col-md-4 mt-10">
                    <div class="sr-border">
                        <img :src="reliability" alt="">
                        <h4 class="mt-3 mb-0 hZUCZe">{{ $t('Proven Reliability') }}</h4>
                        <p class="mt-6-until-sm mt-3 mb-0">{{ $t('With more than 10 years of experience we maintain the highest quality standards in all our work, ensuring that each project is executed with precision and excellence.') }}</p>
                    </div>
                </div>
                <div class="col-md-4 mt-10">
                    <div class="sr-border">
                        <img :src="community" alt="">
                        <h4 class="mt-3 mb-0 hZUCZe">{{ $t('Collaboration') }}</h4>
                        <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We believe in the power of collaboration, both internally within our team and externally with our clients, to achieve mutual success.') }}</p>
                    </div>
                </div>
                <div class="col-md-4 mt-10">
                    <div class="sr-border">
                        <img :src="lowcost" alt="">
                        <h4 class="mt-3 mb-0 hZUCZe">{{ $t('Low Cost') }}</h4>
                        <p class="mt-6-until-sm mt-3 mb-0">{{ $t('the costs are economical enough') }}</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import streamlined from '@/assets/svgs/streamlined.svg'
import performance from '@/assets/svgs/performance.svg'
import publics from '@/assets/svgs/public.svg'
import reliability from '@/assets/svgs/reliability.svg'
import community from '@/assets/svgs/community.svg'
import lowcost from '@/assets/svgs/low-cost.svg'
export default{
    name: "SectionCComponent",
    data() {
        return {
            streamlined,
            performance,
            publics,
            reliability,
            community,
            lowcost,
        };
    },
}
</script>
<style scoped>

</style>